export default [
  {
    path: '/qualifications',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'qualifications-list' */ '@/views/qualifications/List.vue')
  },
  {
    path: '/qualifications/new',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'admin-qualifications-create' */ '@/views/qualifications/Create.vue')
  },
  {
    path: '/qualifications/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'qualification-page' */ '@/views/qualifications/Qualification.vue')
  }
]
